import { Radius } from '@picsart/ds-foundation';
import { ControlSizesXL, ControlSizesLG, ControlSizesMD, ControlSizesSM } from '../../../helpers/ControlSizes/ControlSizes/index.js';

const ButtonSizeXL = {
    ...ControlSizesXL,
    borderWidth: 1,
    borderRadius: Radius.r24,
};
const ButtonSizeLG = {
    ...ControlSizesLG,
    borderWidth: 1,
    borderRadius: Radius.r22,
};
const ButtonSizeMD = {
    ...ControlSizesMD,
    borderWidth: 1,
    borderRadius: Radius.r20,
};
const ButtonSizeSM = {
    ...ControlSizesSM,
    borderWidth: 1,
    borderRadius: Radius.r16,
};

export { ButtonSizeLG, ButtonSizeMD, ButtonSizeSM, ButtonSizeXL };
